.sheet {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0;
  overflow: hidden;
  height: var(--scs-vv-available-h, 100%);
  max-height: 100%;
}

.backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  padding: 0;
  background: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  animation: fadeBackdrop 180ms ease both;
}

.panel {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  width: 100%;
  max-height: var(--scs-vv-panel-max, calc(100% - 8px));
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  border-radius: 15px 15px 0 0;
  padding: 20px;
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.18);
  -webkit-overflow-scrolling: touch;
  transform: translateY(100%);
  transition: transform 0.32s cubic-bezier(0.32, 0.72, 0.33, 1);
}

.panelIn {
  transform: translateY(0);
}

.handle {
  width: 59px;
  height: 6px;
  border-radius: 999px;
  background: #d9d9d9;
  margin: 0 auto;
  flex-shrink: 0;
}

.head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  width: 100%;
  flex-shrink: 0;
}

.title {
  margin: 0;
  text-align: left;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #000;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  flex: 0 1 auto;
}

.preview {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  height: auto;
  flex: 0 1 auto;
  background: #d9d9d9;
  border-radius: 15px;
  overflow: hidden;
}

.iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.done {
  width: 100%;
  min-height: 44px;
  border: 0;
  border-radius: 10px;
  background: #ed1b34;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 15px;
  letter-spacing: 0;
  text-transform: uppercase;
  cursor: pointer;
  flex-shrink: 0;
}

@keyframes fadeBackdrop {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 768px) {
  .sheet {
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .panel {
    width: min(560px, calc(100% - 50px));
    max-height: var(--scs-vv-panel-max, calc(100% - 40px));
    border-radius: 15px;
    padding: 20px 30px;
    flex-shrink: 1;
    transform: translateY(105%);
  }

  .panelIn {
    transform: translateY(0);
  }

  .title {
    font-size: 24px;
  }

  .done {
    font-size: 18px;
    min-height: 48px;
  }
}
